import styled from 'styled-components';
import Icon from '../../assets/images/tick-circle-white-icon.svg';

const TickCircleWhiteIcon = styled.span`
  background: url(\"${Icon}\") no-repeat left center;
  background-size: 28px 28px;
  display: inline-block;
  position: relative;
  width: 28px;
  height: 28px;
`;

export default TickCircleWhiteIcon;
